import React from 'react';
import { Container, Image, Carousel, Button } from 'react-bootstrap';
import scanBg from '../../Assets/Images/ScanQRbackground.png';;
import headerTrac from '../../../server-build/Images/Header.png';
import ContactSignUp from '../../Components/ContactSignUp';

function Traceablility(props) {
   return (

      <div className='container-fluid'>
   
            <div className='row mb-5 tracHeaderImg' style={{ backgroundImage: `url(${headerTrac})` }}>
               <div className='col-12 text-center pt-5 pb-5 my-auto'  >
                  <h2 className='pb-3'>Unlock a world <br className='d-lg-none'/> of information<br />
                     about our fruits</h2>

               </div>
            </div>


            <div className='row mb-5 pb-0 pb-lg-5'>
               <div className='col'>
                  <Container>
                     <div className='row align-items-center '>
                        <div className=' col-12 col-lg-4 mb-4 mb-lg-0'>
                           <p className='mb-0 mb-lg-4 d-none d-lg-block ' >With in-depth details about the <br className='d-none d-lg-block' />
                              exact farm location, the journey <br className='d-none d-lg-block' />
                              from the farm to the store, along<br className='d-none d-lg-block' />
                              with pesticide test reports,</p>
                              <p className='mb-0 mb-lg-4 d-lg-none lh-lg' >With in-depth details about the <br className='d-none d-lg-block' />
                              exact farm location, the journey <br className='d-none d-lg-block' />
                              from the farm to the store, along<br className='d-none d-lg-block' />
                              with pesticide test reports,</p>
                           <h5 className='fw-bold d-none d-lg-block'>we’re bringing you <br className='d-none d-lg-block' />
                              a new level of<br className='d-none d-lg-block' />
                              transparency to the<br className='d-none d-lg-block' />
                              fresh produce market.</h5>
                              <h5 className='fw-bold d-lg-none lh-lg'>we’re bringing you <br className='d-none d-lg-block' />
                              a new level of<br className='d-none d-lg-block' />
                              transparency to the<br className='d-none d-lg-block' />
                              fresh produce market.</h5>
                        </div>

                        <div className='col-12 col-lg-8 traceabilityCarousel '>
                           <Carousel data-bs-theme="dark" touch={true} slide={true}>

                              <Carousel.Item>
                                 <div className='row align-items-center justify-content-center'>
                                    <div className='col-12 col-lg text-center text-md-start mb-4 mb-lg-0'>
                                       <img className='mb-2 img-fluid' src="../../../server-build/Images/TracFruitRatings.png" />
                                    </div>
                                    <div className='col-12 col-lg position-relative '>
                                       <h3 className='fw-bold mb-0 mb-lg-4'>Fruit Ratings</h3>
                                       <p className='mb-4'>Share direct feedback  <br className='d-none d-lg-block'/> about the batch of fruits  <br className='d-none d-lg-block' /> you’re consuming.</p>

                                    </div>
                                 </div>
                              </Carousel.Item>
                              <Carousel.Item>
                                 <div className='row align-items-center justify-content-center'>
                                    <div className='col-12 col-lg text-center text-md-start mb-4 mb-lg-0'>
                                       <img className='mb-2 img-fluid' src='../../../server-build/Images/TracPesticideReports.png' />
                                    </div>
                                    <div className='col-12 col-lg position-relative '>
                                       <h3 className='fw-bold mb-0 mb-lg-4'>Pesticide Reports</h3>
                                       <p className='mb-4'>View reports of tests <br className='d-none d-lg-block' /> conducted at <br className='d-none d-lg-block' />NABL-accredited  labs.</p>

                                    </div>
                                 </div>
                              </Carousel.Item>
                              <Carousel.Item>
                                 <div className='row align-items-center justify-content-center'>
                                    <div className='col-12 col-lg text-center text-md-start mb-4 mb-lg-0'>
                                       <img className='mb-2 img-fluid' src='../../../server-build/Images/TracFruitQuality.png' />
                                    </div>
                                    <div className='col-12 col-lg position-relative '>
                                       <h3 className='fw-bold mb-0 mb-lg-4'>Fruit Quality</h3>
                                       <p className='mb-4'>We track over 20 quality <br className='d-none d-lg-block' /> parameters which you have <br className='d-none d-lg-block' /> direct access to.</p>

                                    </div>
                                 </div>
                              </Carousel.Item>
                              <Carousel.Item>
                                 <div className='row align-items-center justify-content-center'>
                                    <div className='col-12 col-lg text-center text-md-start mb-4 mb-lg-0'>
                                       <img className='mb-2 img-fluid' src='../../../server-build/Images/TracMeettheFarmer.png' />
                                    </div>
                                    <div className='col-12 col-lg position-relative '>
                                       <h3 className='fw-bold mb-0 mb-lg-4'>Meet the<br className='d-none d-lg-block' />
                                          Farmer</h3>
                                       <p className='mb-4'>See who has grown your <br className='d-none d-lg-block'/>
                                          fruits and see how much<br className='d-none d-lg-block' />
                                          more they’ve earned.</p>

                                    </div>
                                 </div>
                              </Carousel.Item>
                              <Carousel.Item>
                                 <div className='row align-items-center justify-content-center'>
                                    <div className='col-12 col-lg text-center text-md-start mb-4 mb-lg-0'>
                                       <img className='mb-2 img-fluid' src='../../../server-build/Images/TracCarbonFootprint.png' />
                                    </div>
                                    <div className='col-12 col-lg position-relative '>
                                       <h3 className='fw-bold mb-0 mb-lg-4'>View Carbon Footprint</h3>
                                       <p className='mb-4'>See how the fruits reached<br className='d-none d-lg-block' /> your store and view the carbon<br className='d-none d-lg-block'/> footprint for each batch too.</p>

                                    </div>
                                 </div>
                              </Carousel.Item>
                              <Carousel.Item>
                                 <div className='row align-items-center justify-content-center'>
                                    <div className='col-12 col-lg text-center text-md-start mb-4 mb-lg-0'>
                                       <img className='mb-2 img-fluid' src='../../../server-build/Images/TracRewardtheFarmer.png' />
                                    </div>
                                    <div className='col-12 col-lg position-relative '>
                                       <h3 className='fw-bold mb-0 mb-lg-4'>Reward the<br className='d-none d-lg-block'/>
                                          Farmer</h3>
                                       <p className='mb-4'>If you’re enjoying the <br  className='d-none d-lg-block'/>
                                          fruits, let the farmer know<br className='d-none d-lg-block' />
                                          with a small reward.</p>

                                    </div>
                                 </div>
                              </Carousel.Item>

                           </Carousel>

                        </div>

                     </div>
                  </Container>
               </div>


            </div>



            <div className="row mb-5 pb-0 pb-lg-5  Traceability-VideoBg justify-content-center align-items-center " style={{ backgroundImage: `url(../../../server-build/Images/TraceabilityvideoThumbnail.jpg)` }}>
               <div className="col">
                  <Container >
                     <div className="row justify-content-center align-items-center">
                        <div className="col text-center">

                           <a href='https://www.youtube.com/embed/mnqP8J0wyAA' target='_blank'> <img src="../../../server-build/Images/Traceability_Play_Button.png" /></a>
                        </div>
                     </div>
                  </Container>

               </div>
            </div>

           

            <div className='row justify-content-center align-items-center mb-3 pb-0 pb-lg-5 backgroundQR position-relative' style={{ backgroundImage: `url(${scanBg})` }}>
            <div className='card shadow position-absolute traceability-card' >
             <div className='card-body text-center' >
            
                  <img  className='rounded-circle traceability-QR img-fluid' src='../../../server-build/Images/QrCode2.png '  />
              
             </div>
           </div>
               {/* <div className='col text-center'>
                  <img src='../../../server-build/Images/QrCode2.png ' className='rounded-circle traceability-QR img-fluid' style={{ boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px' }} />
               </div> */}

            </div>

            <div className='row mb-5 pb-0 pb-lg-5'>
               <div className='col'>
                 <ContactSignUp/>
               </div>
            </div>
         </div>
    


   );


}

export default Traceablility; 